/* eslint-disable */
const UpdateWindowUser = (userObject) => {
    window.Pico.user = userObject
}

export default UpdateWindowUser
